module.exports = "https://bin.bnbstatic.com/_next/static/images/header_bg-943774133122f3987ed38bcc920c0a01.png";